import BarWave1 from "react-cssfx-loading/lib/FadingBalls";

const Loading=()=>{
  return(  <div style={{height:"100vh", width:"100%", background:"black", position:"absolute"}}>
        <div style={{marginTop:"50vh", marginLeft:"47vw"}}><BarWave1 color="red" height="25px" width="25px" /></div>

      </div>)
}
export default Loading;